import { Heading2 } from "@/components/podkit/typography/Headings";
import { type FC } from "react";
import { WorkflowStepCard } from "./AutomationStepCard";
import type { PlainWorkflowAction } from "@/queries/automation-queries";

type WorkflowActionSectionProps = {
    action?: PlainWorkflowAction;
};

export const WorkflowActionSection: FC<WorkflowActionSectionProps> = ({ action }) => {
    const steps = action?.steps || [];
    return (
        <div className="flex flex-col gap-2">
            <Heading2 className="text-base font-medium">Steps</Heading2>
            <div className="flex flex-col">
                {steps.map((step, index) => (
                    <WorkflowStepCard key={index} index={index} step={step} />
                ))}
            </div>
        </div>
    );
};
